
import u from "umbrellajs"
import $ from "jquery"
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

const INIT_COMPLETE_CLASS = "cell--app--current-area-size-unit--selection-menu--button-style__js-init-done"


export interface Selector {
  cell:  string | JQuery | Element
  links: string
}
export interface InputSelector {
  cell?:  string | JQuery | Element
  links?: string
}
const default_selector = {
  cell:  ".cell--app--current-area-size-unit--selection-menu--button-style",
  links: ".cell--app--current-area-size-unit--selection-menu--button-style__item",
}

class Component {
  protected selector: Selector

  protected $cell: JQuery
  protected $links: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)

    this.$cell = $(this.selector.cell)
    this.$links = this.$cell.find(this.selector.links)

    this.bind_action()
  }

  protected bind_action(){
    if (this.$cell.hasClass(INIT_COMPLETE_CLASS)) { return this }

    this.$cell.addClass(INIT_COMPLETE_CLASS)

    this.$links.each((_idx, link) => {
      const $link = u(link)
      const area_size_unit = $link.data("area-size-unit")

      // Current location without protocol/host to avoid unnecessary crawling
      $link.attr("href", window.location.pathname + window.location.search + window.location.hash)

      $link.on("click", async (e) => {
        e.preventDefault()
        await q_ajax_3({
          url:      "/api/web_app/current_area_size_unit",
          method:   "PATCH",
          dataType: "JSON",

          // Sending JSON to server
          contentType:  "application/json; charset=utf-8",
          data:         JSON.stringify({
            area_size_unit: area_size_unit,
          }),
        })
        window.location.reload()
      })
    })
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new Component(selector)
  },
}

export {
  Factory,
}
